<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'

import * as axios from 'axios'

import {
  required,
  // minLength
} from 'vuelidate/lib/validators'

const PUBLISHERS_API_URL = process.env.VUE_APP_API_URL + 'publishers/';
const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';

/**
 * Create publisher form component
 */
export default {
  page: {
    title: 'Publisher Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DatePicker
  },
  data() {
    return {
      title: 'Publisher Form',
      items: [
        {
          text: 'Unblockia',
          href: '/',
        },
        {
          text: 'Publishers',
          href: '/admin/publishers',
        },
        {
          text: '',
          active: true,
        },
      ],
      publisher: {
        name: '',
        lastName: '',
        address: '',
        city: '',
        country: '',
        phone: '',
        bankAccount: '',
        user: '',
        hash: '',
        domain: '',
        currency: '',
        changeCurrencyAt: '',
        adponeHash: '',
        revShare: 80
      },
      submitted: false,
      submitStatus: '',
      advancedSubmitted: false,
      publisherNameError: '',
      currencyList: ['eur', 'usd'],
      demandSourceList: ['unblockia', 'publisher', 'both']
    }
  },
  validations: {
    publisher: {
      name: { required },
      hash: { required },
      currency: {required},
      revShare: {required},
      demandSource: {required},
    },
    
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
    isAdmin: () => {
    return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    },
    isAccountManager: () => {
    return JSON.parse(localStorage["auth.currentUser"]).role.name === "account manager"
    },
    isMediaBuyer: () => {
    return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
    }
  },
  async mounted() {
    if (this.isEdit) {
      const response = await axios(PUBLISHERS_API_URL + this.$route.params.id);
      this.publisher = response.data;
      console.log(this.publisher)
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true
      this.publisherNameError = ''
      // stop here if form is invalid
      this.$v.publisher.$touch()

      if (this.$v.publisher.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(async () => {
          try {
            const action = this.isEdit ? 'put' : 'post'
            const url = !this.isEdit
              ? PUBLISHERS_API_URL
              : PUBLISHERS_API_URL + this.$route.params.id
            const response = await axios[action](url, this.publisher)
            if (!response.data.error){
                this.submitStatus = 'OK';
                this.$router.push('/admin/publishers')
            }else{
                this.submitStatus = 'ERROR'
                this.publisherNameError = response.data.error.toString()
            }
          } catch (e) {
            console.log(e)
            this.submitStatus = 'ERROR'
          }
        }, 500)
      }
    },

    async handleChangeCurrency() {
      this.advancedSubmitted = true;
      const publisherId = this.$route.params.id;
      await axios.put(DASHBOARD_API_URL + `publishers/${publisherId}/change-currency`, {changeCurrencyAt: this.publisher.changeCurrencyAt});
      this.advancedSubmitted = false;


    },

    async toggleGrossEqualToNet() {
      const publisherId = this.$route.params.id;
      try {
          await axios({
              method: 'patch',
              url: DASHBOARD_API_URL + `publishers/${publisherId}/toggle-gross-revenue`
          });
      } catch (e) {
          console.log(e)
      }
    },

    goBack(e) {
      e.preventDefault()
      this.$router.go(-1);
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title">Publisher</h4>
          <p class="sub-header"> Fill the information below </p>
          <b-alert show dismissible variant="danger" v-if="publisherNameError">{{publisherNameError}}</b-alert>
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>
                    Publisher Name
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="publisher.name"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.publisher.name.$error,
                    }"
                  />

                  <div
                    v-if="submitted && !$v.publisher.name.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {{publisher.changeCurrencyAt? 'Initial currency' : 'Currency'}}
                      
                      <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                          :disabled="isEdit"
                          placeholder="Category"
                          v-model="publisher.currency"
                          :options="currencyList"
                  >
                  </b-form-select>
                  <div
                          v-if="submitted && !$v.publisher.currency.required"
                          class="invalid"
                  >
                      This value is required.
                  </div>
                
                </div>
                
                <div class="form-group">
                  <label>Country</label>
                  <country-select
                      v-model="publisher.country"
                      :country="publisher.country"
                      id="country"
                      :countryName="true"
                      placeholder=" "
                      className="custom-select select"/>
                </div>

                <div class="form-group">
                  <label>Address</label>
                  <input
                    v-model="publisher.address"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>Domain</label>
                  <input
                    v-model="publisher.domain"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>
                    Revshare
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    v-model="publisher.revShare"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.publisher.revShare.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.publisher.revShare.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                </div>

                <div class="form-group">
                  <label>Bank account</label>
                  <input
                    v-model="publisher.bankAccount"
                    v-mask="'####-####-####-####'"
                    type="text"
                    class="form-control"
                  />
                  <span class="font-13 text-muted"
                    >e.g "0000-0000-0000-0000"</span
                  >
                </div>
                
              </div>
              <!-- end col -->

              <div class="col-md-6">
                <div class="form-group">
                  <label>Registered Company Name</label>
                  <input
                    v-model="publisher.registeredCompanyName"
                    type="text"
                    class="form-control"
                  />
                </div>
                
                <div class="form-group">
                  <label>City</label>
                  <input
                    v-model="publisher.city"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <input
                    v-model="publisher.phone"
                    v-mask="'(##) ####-####'"
                    type="text"
                    class="form-control"
                  />
                  <!--<span class="font-13 text-muted">e.g "(xx) xxxx-xxxx"</span>-->
                </div>
                <div class="form-group">
                  <label>Unblockia Hash</label>
                  <span class="text-danger">*</span>
                  <input
                  placeholder="Unblockia hash"
                    v-model="publisher.hash"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.publisher.hash.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.publisher.hash.required"
                    class="invalid-feedback"
                  >
                    This value is required.
                  </div>
                </div>

                <div class="form-group">
                  <label>Adpone Hash</label>
                  <input
                  placeholder="Adpone hash"
                    v-model="publisher.adponeHash"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group">
                  <label>
                    Demand source
                      
                      <span class="text-danger">*</span>
                  </label>
                  <b-form-select
                          placeholder="Category"
                          v-model="publisher.demandSource"
                          :options="demandSourceList"
                  >
                  </b-form-select>
                  <div
                          v-if="submitted && !$v.publisher.demandSource.required"
                          class="invalid"
                  >
                      This value is required.
                  </div>
                
                </div>

                <div class="form-group">
                  <label>Child Publisher Network</label>
                  <input
                    v-model="publisher.childPublisherNetwork"
                    type="text"
                    class="form-control"
                  />
                </div>

              </div>
              <!-- end col -->
            </div>
            <div class="row">
              <div class="col-md-12 offset-12">
                <div class="form-group mb-0">
                  <div>
                    <button
                      v-if="submitStatus !== 'PENDING'"
                      type="submit"
                      class="btn btn-primary"
                      >Submit
                    </button>
                    <b-button variant="primary" v-else disabled>
                      <b-spinner small></b-spinner>
                      <span>Loading...</span>
                    </b-button>
                    <button @click="goBack" class="btn btn-secondary m-l-5 ml-1"
                      >Back</button
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
          <!-- end row -->
        </div>
      </div>
      <div v-if="isEdit" class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title">Currency</h4>
          <p class="sub-header"> Fill the information below </p>
          <form @submit.prevent="handleChangeCurrency">
            <div class="form-group pl-0">
                <label>
                    Change currency since
                </label>
                  <date-picker
                      v-model="publisher.changeCurrencyAt"
                      lang="en"
                      value-type="format"
                      format="YYYY-MM-DD"
                      class="col-6"
                      :disabled="!isAdmin"
                  >

                  </date-picker>
                  <div 
                    id="popover-currency" 
                    class="d-inline-flex"
                    v-b-popover.hover.bottom="'If you choose today, we highly recommend you to change the currency tonight or tomorrow early morning'"
                >
                      <i class="mdi mdi-alert-decagram text-warning"></i>
                </div>
            </div>

            <p class="text-warning" v-if="publisher.changeCurrencyAt"
                    >New currency: {{publisher.currency === 'eur' ? 'USD' : 'EUR'}}</p
                  >

            

             <div class="form-group">
                  <div>
                    <button
                      v-if="!advancedSubmitted"
                      type="submit"
                      class="btn btn-primary"
                      :disabled="!isAdmin"
                      >Submit
                    </button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small></b-spinner>
                      <span>Loading...</span>
                    </b-button>
                  </div>
                </div>
          </form>
        </div>

        <div class="card-box">
          <h4 class="header-title">Gross revenue</h4>
            <p class="sub-header">
                Mark it when the publisher has gross revenue equal to net revenue

            </p>

            <div class="custom-control custom-switch">
                <input
                        v-model="publisher.grossEqualToNet"
                        id="isOcm"
                        type="checkbox"
                        class="custom-control-input"
                        @change="toggleGrossEqualToNet"
                />
                <label class="custom-control-label" for="isOcm" > Set Gross revenue equal to Net revenue </label>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
    .invalid{
        color:#f1556c;
        font-size:0.75rem;
    }
    .invalid-input .multiselect__tags{
        border:#f1556c 1px solid !important;
    }
    .mdi-alert-decagram.text-warning{
      font-size: 1.2rem;
    }
    .disabled-text.form-control:disabled{
        color: #999da0;
        background-color: #f2f2f2;
    }
</style>
